module.exports = __webpack_public_path__ + "static/photo-10-de87f433c1d61c8e12f454d579cde44b.jpg";